<template>
  <item-base
    :route-name="routeName"
    icon="lock-fill"
  >
    パスワードの変更
  </item-base>
</template>

<script>
import ItemBase from './Base'

export default {
  components: {
    ItemBase
  },

  data () {
    return {
      routeName: 'password-change'
    }
  }
}
</script>
